import { Icon } from '../../components/icon';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../components/shadcn/tooltip';

const numberFormatter = new Intl.NumberFormat();
export function StatisticBlock({
  title,
  value,
  tooltip,
}: {
  title: string;
  value?: number;
  tooltip?: React.ReactNode;
}) {
  return (
    <div className="flex min-w-min flex-col justify-between rounded-lg border bg-gradient-to-b from-gray-50 to-gray-100 p-4.5 px-5 pb-3.5 shadow-lg/2">
      <div className="mb-3 flex items-center gap-1.5">
        <p className="text-gray-500">{title}</p>
        {tooltip && (
          <TooltipProvider>
            <Tooltip delayDuration={0}>
              <TooltipTrigger asChild>
                <button type="button" className="shrink-0" aria-label={`About ${title}`}>
                  <Icon className="lucide--info h-3.5 w-3.5 text-gray-400" />
                </button>
              </TooltipTrigger>
              <TooltipContent side="top" className="max-w-xs">
                {tooltip}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      <p className="animate-in fade-in h-11 text-4xl font-semibold text-gray-800">
        {value !== undefined ? (
          numberFormatter.format(value)
        ) : (
          <span className="block h-full w-24 animate-pulse rounded-lg bg-gray-200"></span>
        )}
      </p>
    </div>
  );
}
